export const SIGNUP_INPUT = "SIGNUP_INPUT";

export const LOGIN_INPUT = "LOGIN_INPUT";

export const GET_USER_DETAILS = "GET_USER_DETAILS";

export const SET_USER_DETAILS = "SET_USER_DETAILS";

export const ERROR = "ERROR";